"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isCdn = isCdn;
exports.splitNameAndExtension = splitNameAndExtension;
exports.getType = getType;
exports.isImage = isImage;
exports.isVideo = isVideo;
exports.convertUrlToDomain = convertUrlToDomain;
exports.extractFilenameFromUrl = extractFilenameFromUrl;
exports.findAndReplaceHostingInfo = findAndReplaceHostingInfo;
exports.getUpdatedPlayerIdVideoFile = getUpdatedPlayerIdVideoFile;
exports.softDeleteVidyardPlayerIdFromFile = softDeleteVidyardPlayerIdFromFile;
exports.getFileType = getFileType;
exports.getVideoOrImageThumbnailUrl = getVideoOrImageThumbnailUrl;
exports.getHasThumbnail = getHasThumbnail;
exports.getImageSrc = getImageSrc;
exports.isAnimation = isAnimation;
exports.getIsFileManagerUrl = getIsFileManagerUrl;
exports.getShouldRenderFileUrl = getShouldRenderFileUrl;
exports.getFileDetailsFileManagerAppLink = void 0;

var _Url = _interopRequireDefault(require("urlinator/Url"));

var _Constants = require("FileManagerCore/Constants");

var _hubLVideo = require("FileManagerCore/utils/hubLVideo");

var _image = require("FileManagerCore/utils/image");

var _immutable = _interopRequireDefault(require("immutable"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var HUBFS_CDN_URL_REGEX = /\/hubfs\/([0-9]+)\/(.*)/;
var HUBFS_DOMAIN_URL_REGEX = /\/hubfs\/(.*)/;
var LEGACY_CDN_URL_REGEX = /\/hub\/([0-9]+)\/(.*)/;
var LEGACY_DOMAIN_URL_REGEX = /\/hs-fs\/(.*)/;

function isCdn(hostname) {
  var found = false;
  Object.keys(_Constants.CdnHostnames).forEach(function (key) {
    if (_Constants.CdnHostnames[key] === hostname) {
      found = true;
    }
  });
  return found;
}

function splitNameAndExtension(file) {
  var name = file.name;
  /* eslint-disable no-useless-escape */

  var matches = name.match(/(.*)\.([^\.]+)$/);
  /* eslint-enable no-useless-escape */

  if (!matches) {
    return {
      extension: '',
      name: name
    };
  }

  return {
    name: matches[1],
    extension: matches[2].toLowerCase()
  };
}

function getType(extension) {
  var type = _Constants.TypeToExtensions.findKey(function (extensions) {
    return extensions.includes(extension);
  });

  if (type) {
    return type;
  }

  return _Constants.FileTypes.OTHER;
}

function isImage(file) {
  return file.type && file.type.indexOf('image/') === 0;
}

function isVideo(file) {
  return file.type && file.type.indexOf('video/') === 0;
}

function convertUrlToDomain(file, domain) {
  var url = file.get('url');
  var parsed = new _Url.default(url);
  var nextHostname = domain.get('domain');
  var pathname = parsed.pathname;

  var urlScheme = file.getIn(['meta', 'url_scheme']) || _Constants.UrlSchemes.LEGACY;

  if (!domain) {
    return file.get('url');
  }

  if (parsed.hostname === nextHostname) {
    return file.get('url');
  }

  var updates = {
    protocol: domain.get('isSslEnabled') ? 'https' : 'http',
    hostname: nextHostname
  };

  if (isCdn(parsed.hostname) && !isCdn(nextHostname)) {
    if (urlScheme === _Constants.UrlSchemes.SIMPLIFIED) {
      var matches = pathname.match(HUBFS_CDN_URL_REGEX);

      if (matches && matches.length) {
        updates.pathname = "/hubfs/" + matches[2];
      }
    } else {
      var _matches = pathname.match(LEGACY_CDN_URL_REGEX);

      if (_matches && _matches.length) {
        updates.pathname = "/hs-fs/" + _matches[2];
      }
    }
  } else if (!isCdn(parsed.hostname) && isCdn(nextHostname)) {
    if (urlScheme === _Constants.UrlSchemes.SIMPLIFIED) {
      var _matches2 = pathname.match(HUBFS_DOMAIN_URL_REGEX);

      if (_matches2 && _matches2.length) {
        updates.pathname = "/hubfs/" + file.get('portal_id') + "/" + _matches2[1];
      }
    } else {
      var _matches3 = pathname.match(LEGACY_DOMAIN_URL_REGEX);

      if (_matches3 && _matches3.length) {
        updates.pathname = "/hub/" + file.get('portal_id') + "/" + _matches3[1];
      }
    }
  }

  parsed.update(updates);
  return parsed.href;
}

function extractFilenameFromUrl(url) {
  var segments = url.split('/');
  return segments[segments.length - 1];
}

function findAndReplaceHostingInfo(file, hostingInfoReplacement) {
  if (file.getIn(_Constants.PATH_TO_VIDEO_HOSTING_INFO)) {
    return file.getIn(_Constants.PATH_TO_VIDEO_HOSTING_INFO).map(function (hostingInfo) {
      if (hostingInfo.get('provider') === hostingInfoReplacement.get('provider')) {
        return hostingInfoReplacement;
      }

      return hostingInfo;
    });
  }

  return _immutable.default.List([hostingInfoReplacement]);
}

function getUpdatedPlayerIdVideoFile(file, newHostingInfo) {
  return file.setIn(_Constants.PATH_TO_VIDEO_HOSTING_INFO, findAndReplaceHostingInfo(file, newHostingInfo));
}

function softDeleteVidyardPlayerIdFromFile(file, oldPlayerId) {
  return file.setIn(_Constants.PATH_TO_VIDEO_HOSTING_INFO, findAndReplaceHostingInfo(file, _immutable.default.Map({
    provider: _Constants.VideoProviders.VIDYARD,
    status: 'DISABLED',
    id: oldPlayerId
  })));
}

function getFileType(file) {
  if (file.get('type')) {
    return file.get('type');
  }

  return getType(file.get('extension'));
}

function getVideoOrImageThumbnailUrl(file) {
  var thumbSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'thumb';
  return file.getIn(['meta', 'thumbs', thumbSize, 'friendly_url']);
}

function getHasThumbnail(file, thumbSize) {
  var type = getFileType(file);

  if (type === _Constants.FileTypes.IMG && (!!getVideoOrImageThumbnailUrl(file, thumbSize) || file.get('size') <= _Constants.MAX_IMG_SIZE_FOR_THUMBNAIL) || type === _Constants.FileTypes.MOVIE && !!getVideoOrImageThumbnailUrl(file, thumbSize)) {
    return true;
  }

  return false;
}

function getImageSrc(file, thumbSize) {
  if (file.has('tempUrl')) {
    return file.get('tempUrl');
  }

  if (file.has('progress')) {
    return file.get('url');
  }

  var url = getVideoOrImageThumbnailUrl(file, thumbSize) || file.get('url');
  return url + "?t=" + Date.now();
}

function isAnimation(file) {
  return file.getIn(['meta', 'animated']) || false;
}

function getIsFileManagerUrl(url) {
  var parsed = new _Url.default(url);
  var pathname = parsed.pathname;
  var matches = pathname.match(HUBFS_CDN_URL_REGEX);

  if (matches && matches.length) {
    return true;
  }

  matches = pathname.match(HUBFS_DOMAIN_URL_REGEX);

  if (matches && matches.length) {
    return true;
  }

  matches = pathname.match(LEGACY_CDN_URL_REGEX);

  if (matches && matches.length) {
    return true;
  }

  matches = pathname.match(LEGACY_DOMAIN_URL_REGEX);

  if (matches && matches.length) {
    return true;
  }

  return false;
}

var getFileDetailsFileManagerAppLink = function getFileDetailsFileManagerAppLink(file) {
  return window.location.href.replace(window.location.pathname, "/file-manager-beta/" + _hubspot.default.get() + "/" + _Constants.FILE_DETAILS_PATH + "/" + file.get('id'));
};

exports.getFileDetailsFileManagerAppLink = getFileDetailsFileManagerAppLink;

function getShouldRenderFileUrl(_ref) {
  var file = _ref.file,
      hasDirectFileLinkAccess = _ref.hasDirectFileLinkAccess;

  if (hasDirectFileLinkAccess) {
    return !(0, _hubLVideo.isHubLVideo)(file.toJS());
  }

  var fileExtension = file.get('extension') && file.get('extension').toLowerCase();

  switch (getFileType(file)) {
    case _Constants.FileTypes.IMG:
      return !(0, _image.isShutterstock)(file) && file.get('url') && !file.get('temp') && !_Constants.DIRECT_CDN_LINK_INACCESSIBLE_EXTENSIONS.includes(fileExtension);

    case _Constants.FileTypes.MOVIE:
      return !(0, _hubLVideo.isHubLVideo)(file.toJS());

    default:
      return !_Constants.DIRECT_CDN_LINK_INACCESSIBLE_EXTENSIONS.includes(fileExtension);
  }
}